/*eslint-disable*/
import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';

function HireMemoPdfActionButton(props) {

    const [openBox, setopenBox] = useState(false)

    let handleGeneratePdf = (e) => {
        let hireMemo = props.data
        const getGeneratedPdf = hireMemo.generateHireMemoPDF
        const hireMemoNo = hireMemo.hireMemoNo
        getGeneratedPdf(hireMemoNo)
    }


    return (
        <>
            <Button onClick={handleGeneratePdf} basic size="mini" type="button" icon> <Icon name="file pdf" color="red" /></Button>
        </>
    )
}

export default HireMemoPdfActionButton
